function updateProductList(showMore, target) {
  const targetList = document.querySelector(`.${target}-product-grid #product-grid`);
  const fetchUrl = document.querySelector(`.artist-product__show-more--${target}`).getAttribute("href");
  fetch(fetchUrl)
    .then(response => response.text())
    .then(html => {
      const parser = new DOMParser();
      const updateHtml = parser.parseFromString(html, "text/html");


      const newContent = updateHtml.querySelector(`.${target}-product-grid #product-grid`);
      const productCards = Array.from(newContent.querySelectorAll("li.grid__item"));
      console.log(productCards);

      const newMoreLinkElement = updateHtml.querySelector(`.artist-product__show-more--${target}`);
      const newMoreLink = newMoreLinkElement ? newMoreLinkElement.getAttribute("href") : "";
      console.log(newMoreLink);

      productCards.forEach((card) => {
        console.log(card);
        targetList.appendChild(card);
      });

      showMore.setAttribute("href", newMoreLink);
    })
    .catch(error => {
    });
}

window.addEventListener('DOMContentLoaded', () => {
  const showMorePc = document.querySelector(".artist-product__show-more--pc");
  const showMoreSp = document.querySelector(".artist-product__show-more--sp");
  if (showMorePc) {
    showMorePc.addEventListener('click', (e) => {
      e.preventDefault();
      updateProductList(showMorePc, "pc");
    });
  }
  
  if (showMoreSp) {
    showMoreSp.addEventListener('click', (e) => {
      e.preventDefault();
      updateProductList(showMoreSp, "sp");
    });
  }
});
